import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { http } from "../../axios/axios";

import Banner from "../../component/home/Banner";
import Sidebarcard from "../TopProduct/Sidebarcard";
import Solutionsuraksha from "../../component/Solution/Solutionsurauksha";
import Partner from "../CameraCategorySecondPart/Partner";
import CameraCategoryBar from "../CameraCategory/CameraCategoryBar";
import WeOffer from "../home/WhatWeOffer";
import TrendingItems from "../home/TrandingItems";
import ContactSection from "../ContactSection";
import ClientSection from "../home/ClientSection";
import { HomeReviewSection } from "../home/HomeReviewSection";
import HomeServices from "./HomeServices";

const HomePage = () => {
  const [seo, setSeo] = useState(null);

  useEffect(() => {
    fetchSeo();
  }, []);

  const fetchSeo = async () => {
    try {
      const { data } = await http.get("/seo/Home");
      setSeo(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const seoData = seo || {
    metaTitle: "Suraksha 24/7",
    metaDescription:
      "Professional CCTV Camera Installation & Security Surveillance Solutions.",
    metaTags: [],
    schemaScript: null,
  };

  const schemaScript = seoData?.schemaScript
    ? typeof seoData.schemaScript === "string"
      ? seoData.schemaScript
      : JSON.stringify(seoData.schemaScript)
    : null;

  return (
    <>
      <Helmet>
        <title>{seoData?.metaTitle}</title>

        <meta
          name="description"
          content={seoData?.metaDescription}
        />

        <meta
          name="keywords"
          content={
            Array.isArray(seoData?.metaTags)
              ? seoData?.metaTags.join(", ")
              : seoData?.metaTags
          }
        />

        {schemaScript && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: schemaScript }}
          />
        )}
      </Helmet>

      <Banner />
      <WeOffer />
      <Solutionsuraksha />
      <TrendingItems />
      <HomeServices />
      <CameraCategoryBar />
      <Sidebarcard />
      <Partner />
      <ClientSection />
      <HomeReviewSection />
      <ContactSection />
    </>
  );
};

export default HomePage;